import CoreInfographicGrid from './CoreInfographicGrid';

export default CoreInfographicGrid;
